export default {
  recipients: {
    "support@emunworks.com": {
      description: "Resolve an issue with our customer care department",
      icon: "envelope",
      label: "Customer Care"
    },
    "support@emunworks.com": {
      description: "Begin a dialog with one of our credit specialists",
      icon: "envelope",
      label: "Credit"
    }
  },

  toggleRecipient(recipient, model, fieldName = "to") {
    let recipients = (model[fieldName] || "")
      .split(/[,^;:<>!?\n\s\r]+/)
      .filter(r => r && r.length);
    let index = recipients.indexOf(recipient);
    if (index >= 0) {
      recipients.splice(index, 1);
    } else {
      recipients.push(recipient);
    }
    model[fieldName] = recipients.join(", ");
  }
};
